import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { withRouter } from 'react-router-dom';

import { Menu } from 'semantic-ui-react';

import '../css/TopNav.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import { VIEW_SELECTION } from '../managers/NavigationManager';
import { TOP_NAV_NAME } from '../constants';

import InitService from '../services/InitService';
import TopNavService from '../services/TopNavService';
import UserService from '../services/UserService';

export default
@inject(
  'navigationManager',
  'topNavManager',
  'userManager')
@observer
class GenericTopNav extends Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
    this.AriaSkipLink = SatCoreComponent('AriaSkipLink');
    this.LogoButtons = SatCoreComponent('LogoButtons');
    this.ProfileMenu = SatCoreComponent('ProfileMenu');
    this.menuBarRef = React.createRef();
  }

  componentDidMount() {
    const { topNavManager } = this.props;
    topNavManager.setActiveTopNavName(TOP_NAV_NAME.GenericTopNav);
    InitService.initActiveUserRoleAsHtmlBodyAttr();
  }

  componentWillUnmount() {
    InitService.removeHtmlBodyRoleAttr();
  }

  showProfile = () => {
    const { history } = this.props;
    history.push('/profile', { url: history.createHref(history.location) });
  };

  handleLogout = async () => {
    const { history, navigationManager, t, topNavManager } = this.props;

    const strOfItemsToPreserve = '';

    const isRoleSwitcherView = navigationManager.viewSelection === VIEW_SELECTION.ROLE_SWITCHER;

    const externalLogoutUrl = !isRoleSwitcherView ? t('externalLogoutUrl') : t('externalLogoutUrlRoleSwitcher');

    InitService.doLogoutCleanUp(strOfItemsToPreserve, { externalLogoutUrl });

    if (!externalLogoutUrl || !topNavManager.allowLoginRedirectUrl) {
      navigationManager.setView(VIEW_SELECTION.LOGIN);
      history.replace('/signin');
    }
  }

  renderProfileMenu = () => {
    const { ProfileMenu, props: { history, profileMenu, t, userManager } } = this;
    const { profile = true, items, logout = true } = profileMenu || {};

    const { allowSwitchRole } = userManager;
    const hasMultipleRoles = UserService.getAvailableRoleCount() > 1;

    let options = [logout && { onClick: this.handleLogout, text: t('logout') }];
    if (UserService.hasActivePermissionId()) {
      options = [
        profile && {
          className: 'profile',
          onClick: this.showProfile,
          text: t('profile')
        },
        allowSwitchRole && hasMultipleRoles && {
          className: 'switchRole',
          onClick: () => UserService.showRoleSwitcher(history),
          text: t('switchRole')
        },
        ...(items || []),
        logout && { onClick: this.handleLogout, text: t('logout') }
      ];
    }
    return (
      <ProfileMenu
        {...profileMenu}
        options={options} />
    );
  }

  render() {
    const { additionalClassName = '', history, location, t } = this.props;
    const { AriaSkipLink, LogoButtons } = this;

    let topNavClassName = 'topNav';
    topNavClassName += additionalClassName ? ` ${additionalClassName}` : '';

    return (
      <>
        <Menu
          as={(props) => <header id='top-nav-bar' role='tablist' {...props} ref={this.menuBarRef} />}
          className={topNavClassName}
          fixed='top'
          inverted
          onKeyDown={(e) => TopNavService.topNavHandleKeyDown(e, this.menuBarRef)}>
          <LogoButtons history={history} location={location} logoImg={Auth.logoStudent} navButton />
          <AriaSkipLink mainContentId='main-content' />
          <Menu.Menu
            aria-label={t('navigationPanel')}
            as={(props) => <nav {...props} />}
            position='right'
            role='navigation'>
            {this.renderProfileMenu()}
          </Menu.Menu>
        </Menu>
      </>
    );
  }
}

SatCoreRegister('GenericTopNav', withRouter(GenericTopNav));
